var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.ofContent10).length > 1)?_c('div',{staticClass:"of-content-10"},[_c('slider-funnels',{attrs:{"view":_vm.ofContent10}})],1):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772ecf0b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/dashboard/onboardingFunnel/content-10/index.vue
// module id = cDxA
// module chunks = 0